namespace InvData.FormatterHelper {
    const formatters = {};

    export type FormatterOptions = {
        decimalPlaces: number;
        style?: Intl.NumberFormatOptions["style"]; // Intl.NumberFormatOptionsStyle;
    };

    export function getNumberFormatter(options: FormatterOptions): Intl.NumberFormat {
        const key = JSON.stringify(options);
        if (!formatters[key]) {
            formatters[key] = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: options.decimalPlaces,
                maximumFractionDigits: options.decimalPlaces,
                style: options.style || "decimal",
            });
        }
        return formatters[key];
    }

    export function getBasicNumberFormatter(): Intl.NumberFormat {
        const key = "basic";
        if (!formatters[key]) {
            formatters[key] = new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 4,
                style: "decimal",
            });
        }
        return formatters[key];
    }

    export function getWholeNumberFormatter(): Intl.NumberFormat {
        return getNumberFormatter({ decimalPlaces: 0 });
    }

    export function getPercentageFormatter(options: FormatterOptions): Intl.NumberFormat {
        return getNumberFormatter({style: "percent", ...options});
    }

    export function getCurrencyScalarFormatter() {
        const fourFractionalDigitFormatter = getNumberFormatter({ decimalPlaces: 4 });
        const sixFractionalDigitFormatter = getNumberFormatter({ decimalPlaces: 6 });
        const eightFractionalDigitFormatter = getNumberFormatter({ decimalPlaces: 8 });

        return {
            format: (scalar: number) => {
                return scalar >= 0.1 ? fourFractionalDigitFormatter.format(scalar)
                    : scalar >= 0.001 ? sixFractionalDigitFormatter.format(scalar)
                        : eightFractionalDigitFormatter.format(scalar);
            }
        }
    }
}